import { GlobeIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Web = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', ...rest } = props;

  return <GlobeIcon size={Sizes[size]} {...rest} color={fill} />;
};

Web.displayName = 'Web';
